<app-modal [activeModal]="activeModal" [isFooterVisible]="false" [title]="title" [isDismissDisabled]="true">
  <app-domain-error class="mb-6"></app-domain-error>

  <n-vertical-stepper linear #stepper>
    <div *ngFor="let slubowanie of data">
      <n-step
        [label]="slubowanie.kierunekStudiowNazwa"
        i18n-label
        [editable]="false"
        [stepControl]="stepControlDisabled"
      >
        <div class="flex flex-col gap-6">
          <dl class="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
            <div>
              <dt i18n>Kierunek studiów</dt>
              <dd>{{ slubowanie.kierunekStudiowNazwa | empty }}</dd>
            </div>

            <div>
              <dt i18n>Forma studiów</dt>
              <dd>{{ slubowanie.formaStudiowNazwa | empty }}</dd>
            </div>

            <div>
              <dt i18n>Poziom kształcenia</dt>
              <dd>{{ slubowanie.poziomKsztalceniaNazwa | empty }}</dd>
            </div>

            <div class="md:col-span-2 xl:col-span-3">
              <dt i18n>Treść</dt>
              <dd>{{ slubowanie.tresc | empty }}</dd>
            </div>
          </dl>

          <button
            ndt-secondary-button
            type="button"
            class="self-center"
            (click)="akceptujSlubowanie(slubowanie.programStudiowStudentaSlubowanieId)"
            i18n
          >
            Akceptuj Ślubowanie
          </button>
        </div>
      </n-step>
    </div>
  </n-vertical-stepper>
</app-modal>
